import React from "react";
import { Container } from "@chakra-ui/react";
import ListSubCategory from "views/admin/SubCategory/components/ListSubCategory";

const SubCategory = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListSubCategory />
    </Container>
  );
};

export default SubCategory;
